import { RefreshCw } from 'lucide-react';

export function CrawlForceRecrawlToggle({ forceRecrawl, setForceRecrawl, crawling }) {
  return (
    <div className="flex items-start gap-2 rounded-sm border border-zinc-800 bg-zinc-900/30 p-3">
      <input
        type="checkbox"
        id="forceRecrawl"
        data-testid="force-recrawl-checkbox"
        checked={forceRecrawl}
        onChange={(event) => setForceRecrawl(event.target.checked)}
        disabled={crawling}
        className="mt-0.5 h-4 w-4 rounded border-zinc-800 bg-zinc-900 accent-amber-400"
      />
      <div className="flex-1 space-y-1">
        <label htmlFor="forceRecrawl" className="flex items-center gap-1.5 text-sm font-medium">
          <RefreshCw className="h-3.5 w-3.5 text-amber-400" />
          Forcer la mise à jour des URLs déjà indexées
        </label>
        <p className="text-xs text-zinc-500">
          Réécrase les pages existantes pour récupérer images, contenu mis à jour ou corrections. Utile si le RAG ne voit pas les images d'indexations précédentes.
        </p>
      </div>
    </div>
  );
}
